<script lang="ts">
	interface Props {
		direction?: string;
		triggerStyle?: string;
		children?: import('svelte').Snippet;
		menu?: import('svelte').Snippet;
	}

	let { direction = 'down', triggerStyle = '', children, menu }: Props = $props();

	let showMenu = $state(false);

	const openMenu = () => {
		showMenu = true;
	};

	const closeMenu = () => {
		showMenu = false;
	};
</script>

<div class="dropdown-container">
	<button class="button trigger" onmousedown={openMenu} aria-label="Language" style={triggerStyle}>
		{@render children?.()}
	</button>
	{#if showMenu}
		<button class="menu-overlay" onclick={closeMenu} aria-label="menu"></button>
		<div
			class="menu"
			class:up={direction === 'up'}
			style="left: {direction === 'right' ? 'unset' : '0px'}; right: {direction === 'right'
				? '0px'
				: 'unset'}"
			onclick={closeMenu}
			onkeydown={closeMenu}
			onkeyup={closeMenu}
			role="menu"
			tabindex="-1"
		>
			{@render menu?.()}
		</div>
	{/if}
</div>

<style>
	.menu-overlay {
		background: unset;
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
	}
	.menu {
		min-width: 90px;
		background: var(--white);
		position: absolute;
		top: calc(40px + 0.5rem);
		left: 0px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		padding: 0.25rem 0;
		border-radius: 1rem;
		overflow: hidden;
		box-shadow: 0px 10px 20px -10px rgba(49, 8, 23, 0.25);
		border: 2px solid var(--primary-color-5);
		animation: fadeIn 0.5s cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	@keyframes fadeIn {
		from {
			opacity: 0;
			transform: translateY(-10px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}

	.up {
		top: -0.5rem;
		transform: translateY(-100%);
		animation: fadeUp 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(-90%);
		}
		to {
			opacity: 1;
			transform: translateY(-100%);
		}
	}

	.trigger {
		margin: 0;
		background-color: transparent;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		border: 2px solid var(--burgundy-10);
		gap: 0.5rem;
		padding: 0.2rem 0.8rem;
		line-height: 0;
		padding: 0.2rem 0.8rem;
		position: relative;
		overflow: hidden;
		font-weight: 700;
		transition: background-color 0.8s cubic-bezier(0.075, 0.82, 0.165, 1);
	}

	.trigger:hover {
		background: var(--burgundy-5);
	}

	.dropdown-container {
		position: relative;
	}

	.dropdown-container:hover {
		z-index: 1000;
	}
</style>
